import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SharedWithdrawalService {
  private dataWithdrawalSource = new BehaviorSubject<any>({});

  getDataWithdrawalInfo$ = this.dataWithdrawalSource.asObservable();
  constructor() { }
  /**
   * [setData]
   * @param data
   * @param origin
   */
  setDataWithdrawal(data: any, origin: string) {
    const objSend = {
      data: data,
      origin: origin,
    };

    this.dataWithdrawalSource.next(objSend);
  }


}
